$( document ).ready(function() {
  setTimeout(function(){
    $(".notifyButtonStyle").css("border-radius", "0");
  }, 1000);
  
  $(function () {
  	$('.popup-modal').magnificPopup({
  		type: 'inline',
  		preloader: false,
  		focus: '#newslatter_popup-input',
  		modal: true
  	});
  	$(document).on('click', '.popup-modal-dismiss', function (e) {
  		e.preventDefault();
  		$.magnificPopup.close();
  	});
  });

  // Collection List Slider

  $('.collection-list').slick({
    dots: false,
    arrows: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });

  var sLightbox = $('.collection-list');
  sLightbox.slickLightbox({
    src: 'src',
    itemSelector: '.collection-list__item'
  });
  
//   var panels = document.querySelectorAll('li.collection-list__item');
//   for (var i = 0; i < panels.length; i++) {
//     panels[i].addEventListener('click', function (event) {
//       $('.collection-list').slickLightbox({
//         src: 'src',
//         itemSelector: 'li.collection-list__item',
//         navigateByKeyboard: true,
//         dots: true,
//         infinite: true,
//         centerMode: true,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         mobileFirst: true
//       });
//   });
// }

  
$(".collection-list").on("afterChange", function(event, slick, currentSlide){
    $(".collection-list-arrows .current_slide").text(parseInt(slick.currentSlide + 1));
    // $(".collection-list-arrows .current_slide").text(parseInt(slick.currentSlide + 1) + ' / ' + slick.slideCount);
   
});
  

   // if($('body').hasClass('index')){
   //   var url = window.location.href;
   //   console.log(url);
   //   if(url.includes('customer_posted=true')){
   //     setTimeout(function() {
   //      $(document).find('.footer #newsletter-popup-modal').trigger('click');
   //     }, 1000);
   //   }else{
   //     setTimeout(function() {
   //      $(document).find('.footer #newsletter-popup-modal').trigger('click');
   //    }, 3500);
   //   }
   // }

   //get set cookie for newsletter
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    }

    function setCookie(name,value,days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  
    var myCookie = getCookie('newsletter_subscribe');
    if (myCookie == null) {
       var url = window.location.href;
       console.log(url);
       if(url.includes('customer_posted=true')){
         setTimeout(function() {
          $(document).find('.footer #newsletter-popup-modal').trigger('click');
          $('#newsletter-popup').find('.newslatter_popup-input,button[type="submit"]').css('display','none');
          $('#newsletter-popup').find('h3.newsletter-form__message--success').css('justify-content','center');
          setCookie('newsletter_subscribe','subscribed');
         }, 500);
       }else if(url.includes('form_type=customer')){
         setTimeout(function() {
          $(document).find('.footer #newsletter-popup-modal').trigger('click');
         }, 500);
       }else if(url.includes('challenge#')){
         console.log('no');
       }else{
         setTimeout(function() {
          $(document).find('.footer #newsletter-popup-modal').trigger('click');
        }, 15000);
       }
    }
    $('#newsletter-popup .newslatter_popup-close .popup-modal-dismiss').click(function(){      
       var url = window.location.href;
       console.log(url);
       if(url.includes('customer_posted=true')){
         setCookie('newsletter_subscribe','subscribed');
       }else{
         setCookie('newsletter_subscribe','not_subscribed');
       }
    });
});

window.addEventListener('load', function() {
  var pHandle = $(".product__info-container").attr("data-handle");
  var onLoadId = window.location.href;
  var parts = onLoadId.split("variant=");
  if (window.location.href.indexOf("variant=") > -1) {
    var last_part = parts[parts.length-1];
  }
  $(".product-form__input input").each(function(){
    var variantid = $(this).attr("data-variant");
    if (last_part == variantid) {
       $(this).attr("checked",true);
    }
  });  
});
